/**
 * The action bar: nine hotkeys (the loadout's action slots). A hotkey is a
 * quick link, not extra inventory: it points at a carried inventory slot
 * (triggering whatever item occupies that slot) or at a skill. Which slot
 * points at what, and which key presses each slot, are account-level user
 * settings. Every account starts with Draw in the last slot, on D, and the
 * rest unassigned on 1-8.
 */

/** Number of action-bar hotkeys (the loadout's action slots). */
export const ACTION_BAR_HOTKEY_COUNT = 9 as const;

/** The slot every account starts with Draw in: the last one. */
export const DRAW_ACTION_BAR_INDEX = ACTION_BAR_HOTKEY_COUNT - 1;

/** What one hotkey triggers, or null when unassigned. */
export type ActionBarHotkeyTarget =
    /** Whatever item occupies this carried inventory slot. */
    | { readonly kind: 'carried-slot'; readonly slotIndex: number }
    /** A skill. Modeled now; no skills have actions yet, so this does nothing when triggered. */
    | { readonly kind: 'skill'; readonly skillId: string }
    | null;
